import { render, staticRenderFns } from "./tButton.vue?vue&type=template&id=08096eb8"
import script from "./tButton.vue?vue&type=script&lang=js"
export * from "./tButton.vue?vue&type=script&lang=js"
import style0 from "./tButton.vue?vue&type=style&index=0&id=08096eb8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports